exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}", ""]);
